module.exports = __webpack_public_path__ + "4ba7c1e15a8cc1e5ead0518637f2f377.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/locations/newmexico.png
// module id = 3255
// module chunks = 69